import React, { useEffect, useState, useCallback } from 'react'
import { Box, Typography, Divider, Paper, Grid, SpeedDial, Card, CardContent, CardActions,
  Chip, FormControl, RadioGroup, FormControlLabel, Radio, Button
} from '@mui/material';
import Modal from 'components/Modal';
import AddIcon from '@mui/icons-material/Add';
import { useSnackbar } from 'notistack';
import AddEnquiry from './Add';
import useConfirm from 'core/hooks/useConfirm';
import { getEnquiries, getEnquiryDetails, deleteEnquiry } from 'services/enquiries';

const Enquiries = () => {

  const [openModal, setOpenModal] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [enquiryList, setEnquiryList] = useState([]);
  const [enquiryDetails, setEnquiryDetails] = useState(null);
  const confirm = useConfirm();
  const [filteredStatus, setFilteredStatus] = useState('')

  useEffect(() => {
    getAllEnquiries();
  }, []);

  const onModalClose = useCallback(
    () => {
      setOpenModal(false);
    },
    [setOpenModal],
  )

  function getAllEnquiries() {
    getEnquiries().then(({response, error}) => {
      if(response){
        setEnquiryList([...response]);
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }

  const onEnquiryAdded = useCallback(
    () => {
      getAllEnquiries();
      setOpenModal(false);
      setEnquiryDetails(null)
    },[]);

  const onEnquiryDelete = (e,id) => {
    e.stopPropagation();
    setEnquiryDetails(null);
    if(id) {
      confirm({ title: 'Delete Enquiry?', description: 'Are you sure you want to delete enquiry?' })
    .then(() => { 
      deleteEnquiryData(id);
    })
    }
  };

  const deleteEnquiryData = (id) => {
    deleteEnquiry({id}).then(({response, error}) => {
      if(response){
        enqueueSnackbar((response?.message || "Pass deleted successfully"), {variant: 'success'});
        getAllEnquiries();
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }

  const onAddEnquiryBtnClick = (e) => {
    setEnquiryDetails(null)
    setOpenModal(true);
  };

  const onCardClick = (e,id) => {
    e.preventDefault();
    getEnquiryDetails({id}).then(({response, error}) => {
      if(response){
        setEnquiryDetails({...response})
        setOpenModal(true);
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }


  return (
    <Paper sx={{ minWidth: 275, py: 2, px: 3, minHeight: "calc(100vh - 100px )" }}>
      <Typography component="h2" variant="h6" color="secondary" gutterBottom sx={{mb: 1}}>
        Enquiries
      </Typography>
      <Divider />
      <Box noValidate  sx={{ mt: 2 }} >
        <Grid container columnSpacing={4} rowSpacing={2} >
        <Grid item xs={12} sm={12} md={12} xl={12} lg={12} >
            <Paper elevation={0} sx={{p:1, bgcolor: "#f3f3f3"}}>
              <Typography variant="subtitle2" gutterBottom component="div">
                Filters
              </Typography>
              <Box sx={{mt: 1}}>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="Filter by status"
                    name="status-group"
                    defaultValue=""
                    onChange={(event) => setFilteredStatus(event.target.value)}
                  >
                    <FormControlLabel  value="" control={<Radio />} label="All" />
                    <FormControlLabel value="Open" control={<Radio />} label="Open" />
                    <FormControlLabel value="Closed" control={<Radio />} label="Closed" />
                  </RadioGroup>
                </FormControl>
              </Box>
            </Paper>
          </Grid>
          {enquiryList.map((enquiry, index) =>( filteredStatus === "" || enquiry.status === filteredStatus) ? (
            <Grid item xs={10} sm={6} md={6} xl={3} lg={4} key={index} >
              <Card sx={{  position: 'relative',  height: '100%'}} >
                <Chip label={enquiry.status || 'Open'} color="primary" sx={{position: 'absolute', top: '8px', right: '8px'}} />
                <CardContent onClick={(e) => onCardClick(e, enquiry?.enquiryId)} sx={{cursor: 'pointer'}}>
                  <Typography gutterBottom variant="body1" component="div">
                    {enquiry.name}
                  </Typography>
                  <Typography gutterBottom variant="body2" component="div">
                    {enquiry.mobileNumber}  
                  </Typography>
                 
                  <Typography gutterBottom variant="caption" component="div" color="primary.dullBlack">
                    Follow up on {enquiry.followUpDate}
                  </Typography>

                </CardContent>
                {/* <CardActions  sx={{ position: 'absolute', top: 0, right: 0}}>
                  <IconButton variant="raised"  onClick={(e) => onPassDelete(e, enquiry?.enquiryId)}
                  >
                    <DeleteForeverIcon sx={{color: '#9d3939'}} />
                  </IconButton>
                </CardActions> */}
                <CardActions >
                  <Button size="small" color="secondary"  onClick={(e) => onEnquiryDelete(e, enquiry?.enquiryId)}>Delete</Button>
                </CardActions>
               
              </Card>
            </Grid>
          ): null)}
        </Grid>
      </Box>
      <SpeedDial
        onClick={onAddEnquiryBtnClick}
        ariaLabel="Add Pass"
        sx={{ position: 'absolute', bottom: 75, right: 75 }}
        icon={<AddIcon />}
      />
      <Modal
        maxWidth={"sm"}
        open={openModal} 
        onModalClose={onModalClose}
        title={enquiryDetails ? 'Update Enquiry' : 'Add Enquiry'}
      >
        <AddEnquiry onEnquiryAdded={onEnquiryAdded} enquiryDetails={enquiryDetails} />
      </Modal>
    </Paper>
  );
}
 
export default React.memo(Enquiries);
